import React, { useContext, useState } from "react";

import useModal from "@hooks/useModal";
import { ApplicationContext } from "@context/ApplicationContext";
import { AuthContext } from "@context/AuthContext";
import { BookSessionContext } from "@context/BookSessionContext";
import { SessionContext } from "@context/SessionContext";
import Button from "@components/Ui/Button";
import Checkbox from "@components/Ui/Checkbox";
import Drawer from "@components/V3/Drawer";
import TermsPage from "@pages/TermsPage";
import "./style.scss";


const TermsDrawer = () => {
    const { openModalWithContent, portal } = useModal();
    const { drawerState, closeDrawer, pendingActionUrl, setPendingActionUrl } = useContext(AuthContext);
    const { whiteLabel } = useContext(ApplicationContext);
    const { termsAccepted, setTermsAccepted, fetchReInitialiseEwayTicket, uuid } = useContext(BookSessionContext);

    const [selectedOption, setSelectedOption] = useState("vouchers");

    const handleContinue = () => {
        closeDrawer("termsDrawer");

        if (pendingActionUrl) {
            if (selectedOption === "cinema") {
                fetchReInitialiseEwayTicket(uuid);
            }
            else
            {
                window.open(pendingActionUrl, "_self");
                setPendingActionUrl(null);
            }
        }
    };

    return (
        <>
            <Drawer
                id="termsDrawer"
                role="dialog"
                aria-modal="true"
                aria-label="Terms and conditions"
                isOpen={drawerState.termsDrawer}
                onClose={() => closeDrawer("termsDrawer")}
                closeButtonAlignment="right"
            >
                {whiteLabel?.enable_agentic_ai === true && (
                    <div className="terms-drawer__wrapper">
                        <h2 className="terms-drawer__title">Reserve Seats</h2>
                        <p className="terms-drawer__text">
                            We&apos;ve reserved movie vouchers for your session. Our AI agent can help you choose
                            your seat and complete the booking at the cinema website
                            (booking fees apply) OR you can take your vouchers and show them at the
                            box office (no booking fees apply)
                        </p>

                        <div className="terms-drawer__buttons">
                            <Button
                                additionalClasses={`button button__secondary terms-drawer__button ${
                                    selectedOption === "cinema" ? "active" : ""
                                }`}
                                onClick={() => setSelectedOption("cinema")}
                            >
                                Book with Cinema
                            </Button>
                            <Button
                                additionalClasses={`button button__secondary terms-drawer__button ${
                                    selectedOption === "vouchers" ? "active" : ""
                                }`}
                                onClick={() => setSelectedOption("vouchers")}
                            >
                                Take the Vouchers
                            </Button>
                        </div>
                    </div>
                )}

                <Checkbox
                    buttonAlignment="left"
                    checked={termsAccepted}
                    onChange={() => setTermsAccepted(!termsAccepted)}
                >
                    I accept the{" "}
                    <a
                        href="#terms"
                        className="inline-link"
                        onClick={(e) => {
                            e.preventDefault();
                            openModalWithContent(<TermsPage />, "medium");
                        }}
                    >
                        Terms &amp; Conditions
                    </a>{" "}
                    of purchase
                </Checkbox>
                <Button
                    additionalClasses="button button__primary"
                    disabled={!termsAccepted}
                    onClick={handleContinue}
                >
                    Continue
                </Button>
            </Drawer>
            {portal}
        </>
    );
};

export default TermsDrawer;
